<template>
  <transition appear name="slide-fade" mode="out-in">
    <router-view :csrf-token="csrfToken" :order_code="order_code"></router-view>
  </transition>
</template>

<script>
import { eventBus } from "../../app";
import {
  GET_ADDRESS_DATA,
  GET_PERSONAL_DATA,
  SET_ADDRESS_DATA_MUTATION,
  SET_PERSONAL_DATA_MUTATION,
  SET_CARDS,
  RETREIVE_REGIONS,
} from "../../store/wizard/types";
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  props: {
    personalData: {
      type: Object,
      required: false,
    },
    address: {
      type: Object,
      required: false,
    },
    cards: {
      type: Array,
      required: false,
    },
    order_code: {
      type: String,
      default: ""
    },
    csrfToken: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters({
      addressObject: GET_ADDRESS_DATA,
      personalObject: GET_PERSONAL_DATA,
    }),
  },
  methods: {
    ...mapMutations({
      setAddressData: SET_ADDRESS_DATA_MUTATION,
      setPersonalData: SET_PERSONAL_DATA_MUTATION,
      setCards: SET_CARDS,
    }),
    ...mapActions({
      retreiveRegions: RETREIVE_REGIONS,
    }),
  },
  created() {
    this.retreiveRegions();
    const address = { ...this.addressObject };
    const personal = { ...this.personalObject };
    if (this.address) {
      address.personal.address.value = this.address.address;
      address.personal.info.value = this.address.extra_info;
      address.postal.value = this.address.postal_code;
      address.country.value = this.address.country;
      address.observations.value = this.address.observations;
      address.personal.city.value = this.address.city;
      address.personal.name.value = this.address.name;
      address.personal.surname.value = this.address.surname;
    }

    if (this.personalData) {
      personal.email.value = this.personalData.email;
      personal.phone.value = this.personalData.phone;
      personal.phone_prefix.value = this.personalData.phone_prefix;
      personal.dni.value = this.personalData.dni;
    }

    this.setAddressData(address);
    this.setPersonalData(personal);
    this.cards && this.setCards(this.cards);

    eventBus.$on("something-went-wrong", (toPath) => {
      this.$toast.error(this.trans.get("customer.something-went-wrong"));
    });
  },
};
</script>

<style lang="scss">
</style>
